module.exports = __webpack_public_path__ + "static/media/icon_main_cattleplanning.6044d84c.png";